var _g, _g2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgClock(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "clock",
    xmlns: "http://www.w3.org/2000/svg",
    width: 14.307,
    height: 14.307,
    viewBox: "0 0 14.307 14.307",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_17088",
    "data-name": "Group 17088",
    transform: "translate(6.599 3.319)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_17087",
    "data-name": "Group 17087"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_38267",
    "data-name": "Path 38267",
    d: "M239.272,123.877l-1.995-1.5v-3.047a.554.554,0,1,0-1.108,0v3.325a.553.553,0,0,0,.222.443l2.216,1.662a.554.554,0,0,0,.665-.887Z",
    transform: "translate(-236.169 -118.779)",
    fill: "#848689"
  })))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "Group_17090",
    "data-name": "Group 17090"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_17089",
    "data-name": "Group 17089"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_38268",
    "data-name": "Path 38268",
    d: "M7.153,0a7.153,7.153,0,1,0,7.153,7.153A7.161,7.161,0,0,0,7.153,0Zm0,13.2A6.045,6.045,0,1,1,13.2,7.153,6.053,6.053,0,0,1,7.153,13.2Z",
    fill: "#848689"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgClock);
export default __webpack_public_path__ + "static/media/clock.7dce2f9f.svg";
export { ForwardRef as ReactComponent };